import React from "react";
import {
  Input,
} from "reactstrap";
import { InfoContainer, InfoText } from "../ConfirmModal/confirmModalComponents";

export default function InfoContainerComponent({
  title,
  value,
  canEdit,
  handleChange,
}) {
  return (
    <InfoContainer>
      <h3 style={{ textAlign: "center", margin: 0, fontWeight: 400 }}>{title}</h3>
      <div style={{ marginTop: "10px", maxWidth: "95%" }}>
        {canEdit ? (
          <Input
            type="text"
            value={value}
            onChange={(e) => handleChange(e.target.value)}
            style={{
              textAlign: "center",
              fontWeight: "600",
              border: "none",
              borderBottom: "1px solid #ccc",
              backgroundColor: "transparent",
              padding: "2px 4px",
              outline: "none",
            }}
          />
        )
          : (
            <InfoText
              style={{
                textAlign: "center",
                fontWeight: "600",
                border: "none",
                backgroundColor: "transparent",
                padding: "2px 4px",
                outline: "none",
              }}
            >
              {value || "Não Informado"}
            </InfoText>
          )
        }
      </div>
    </InfoContainer>
  );
}
